import { Skeleton } from "@/components/ui/skeleton"

export default function AnalyzeOrderSkeleton() {
  return (
    <div className="flex h-full w-full flex-col">
      {/* Header Controls Skeleton */}
      <div className="flex flex-wrap gap-2 px-4 py-2">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-8 w-20" />
      </div>

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-hidden">
        <div className="space-y-4 px-4">
          {/* Road Tolls Section Skeleton */}
          <div className="space-y-4">
            <Skeleton className="h-6 w-20" />

            {/* Country Breakdown Skeleton */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-4 w-6 rounded-sm" />
                  <Skeleton className="h-5 w-32" />
                </div>
                <Skeleton className="h-5 w-28" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-4 w-6 rounded-sm" />
                  <Skeleton className="h-5 w-20" />
                </div>
                <Skeleton className="h-5 w-16" />
              </div>
            </div>

            {/* Total Skeleton */}
            <div className="flex items-center justify-between border-t pt-2 font-semibold">
              <Skeleton className="h-6 w-12" />
              <Skeleton className="h-6 w-20" />
            </div>
          </div>

          {/* Route Stops Section Skeleton */}
          <div className="space-y-3">
            {/* Starting Point Skeleton */}
            <div className="flex items-center gap-4">
              <Skeleton className="h-5 w-5 rounded-full" />
              <div className="flex-1">
                <Skeleton className="h-5 w-32" />
              </div>
            </div>

            {/* Intermediate Stop 1 Skeleton */}
            <div className="flex items-start gap-4">
              <div className="flex flex-col items-center">
                <Skeleton className="h-6 w-5 rounded-sm" />
              </div>
              <div className="flex-1 space-y-1">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-5 w-40" />
                  <div className="flex items-center gap-4">
                    <Skeleton className="h-6 w-12 rounded-full" />
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-4 w-4 rounded-sm" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                  </div>
                </div>
                <Skeleton className="h-4 w-32 text-gray-500" />
              </div>
            </div>

            {/* Intermediate Stop 2 Skeleton */}
            <div className="flex items-start gap-4">
              <div className="flex flex-col items-center">
                <Skeleton className="h-6 w-5 rounded-sm" />
              </div>
              <div className="flex-1 space-y-1">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-5 w-48" />
                  <div className="flex items-center gap-4">
                    <Skeleton className="h-6 w-14 rounded-full" />
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-4 w-4 rounded-sm" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                  </div>
                </div>
                <Skeleton className="h-4 w-36 text-gray-500" />
              </div>
            </div>

            {/* Add New Stop Skeleton */}
            <div className="flex items-center gap-4 pt-4">
              <Skeleton className="h-5 w-5 rounded-sm" />
              <Skeleton className="h-5 w-24" />
            </div>
          </div>
        </div>
      </div>

      {/* Message Area Skeleton - Fixed to bottom */}
      <div className="w-full border-t bg-[var(--panel-color)] p-4">
        <div className="space-y-2">
          <Skeleton className="h-20 w-full rounded-md" />
          <div className="flex items-center justify-end gap-1">
            <Skeleton className="h-8 w-8 rounded-sm" />
            <Skeleton className="h-8 w-8 rounded-sm" />
            <Skeleton className="h-8 w-32 rounded-md" />
          </div>
        </div>
      </div>
    </div>
  )
}
